// © Microsoft Corporation. All rights reserved.
import React, { useState, useEffect, useCallback, Fragment } from 'react';
import GroupCall from './containers/GroupCall';
import { Provider } from 'react-redux';
import EndCall from './components/EndCall';
import { Survey } from './components/Survey';
import Header from './Header';
import ScheduleMeeting from './components/ScheduleMeeting';
import ConfigurationScreen from './containers/Configuration';
import { loadTheme, initializeIcons, Stack, IStackStyles, IStackItemStyles, Spinner } from '@fluentui/react';
import { utils } from './Utils/Utils';
import { CallEndReason, GroupLocator, TeamsMeetingLinkLocator, CallClient } from '@azure/communication-calling';
import { store } from 'core/store';
import { Paper } from "@material-ui/core";
import { initLogger } from 'feedbacks/logger';
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import { createTheme } from "@material-ui/core/styles";
import Thankyou from './components/Thankyou';
import SettingsIcon from '@material-ui/icons/Settings';
import TextField from '@material-ui/core/TextField';
import { SketchPicker } from 'react-color';
import Tooltip from '@material-ui/core/Tooltip';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
import {
  localStorageAvailable,
  getDisplayPCFromLocalStorage,
  saveDisplayPCToLocalStorage,
  getDisplayDCFromLocalStorage,
  saveDisplaySCToLocalStorage,
  getDisplayEmailFromLocalStorage
} from './Utils/localStorage';
import { saveChatMessages, leaveMeeting } from './core/chatSideEffects';
import { stopRecord } from './core/sideEffects';
import { getMeetingInformationData } from './core/chatSideEffects';
import {
  Default_URL
} from './constants';
import browserList from "./browser-list.png"
const sdkVersion = require('../package.json').dependencies['@azure/communication-calling'];
const lastUpdated = `Last Updated ${utils.getBuildTime()} with @azure/communication-calling:${sdkVersion}`;

loadTheme({});
initializeIcons();
initLogger();

const theme = createTheme({
  typography: {
    fontFamily: "Segoe UI",
    fontSize: 14,
    h1: {
      fontSize: "3rem"
    }
  },
  overrides: {
    MuiButton: { // Name of the component ⚛️ / style sheet
      root: { // Name of the rule
        textTransform: "none",
      },
    },
  }
});

const containerStyles: IStackStyles = {
  root: {
    width: '100%',
    height: '100%'
  }
};
export const stackItemStyles: IStackItemStyles = {
  root: {
    width: '100%',
    minHeight: '5rem',
    background: 'black'
  }
};
export const stackItemsStyles: IStackItemStyles = {
  root: {
    width: '100%'
  }
};

const App = (): JSX.Element => {
  // var str = "Ramakrishna Parimi: Hi<br>Anil P: Hi<br/>Ramakrishna Parimi: How are you?<br/>Anil P: FIne<br/>";
  // console.log(str.replace(/<br[^>]*>/g, "\n"))
  const spinnerLabel = 'Initializing data...';
  const [page, setPage] = useState('configuration');
  const [loader, setLoader] = useState(true);
  const [callData, setCall] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [rejoin, setRejoin] = useState(false);
  const [groupId, setGroupId] = useState('');
  const [callEndReason, setCallEndReason] = useState<CallEndReason | undefined>();
  const [screenWidth, setScreenWidth] = useState(0);
  const [settingBox, setSettingBox] = useState(false);
  const [colorPicker1, setColorPicker1] = useState(false);
  const [colorPicker2, setColorPicker2] = useState(false);
  const [darkColor, setDarkColor] = useState('#009C9D');
  const [lightColor, setLightColor] = useState('#03C0C1');
  const [darkColor1, setDarkColor1] = useState('#009C9D');
  const [lightColor1, setLightColor1] = useState('#03C0C1');
  const [homeColor, setHomeColor] = useState('#03FDFC');
  const [className, setClassname] = useState('default');
  const [messages, setMessages] = useState([]);
  const defaultDisplayEmail = localStorageAvailable ? getDisplayEmailFromLocalStorage() : null;
  const [employeesCount, setEmployeesCount] = useState(0);
  const [meetingData, setMeetingData] = useState('');
  const [userMessage, setUserMessage] = useState('');
  // const [cameraEnabled, setCameraEnabled] = useState(false);
  // const [microphoneEnabled, setMicrophoneEnabled] = useState(false);
  // 009C9D
  const unsupportedStateHandler = useCallback((): void => setPage('unsupported'), []);

  useEffect(() => {
    const setWindowWidth = () => {
      const width = typeof window !== 'undefined' ? window.innerWidth : 0;
      setScreenWidth(width);
    };
    setWindowWidth();
    window.addEventListener('resize', setWindowWidth);
    window.addEventListener('scroll', listenScrollEvent);
    document.documentElement.style.setProperty('--dc-color', darkColor);
    document.documentElement.style.setProperty('--lc-color', lightColor);
    document.documentElement.style.setProperty('--banner-color', darkColor);
    saveDisplaySCToLocalStorage(lightColor);
    return () => window.removeEventListener('resize', setWindowWidth);
  }, []);

  // useEffect(() => {
  //   const checkDeviceStatus = async () => {
  //     try {
  //       // const callClient = new CallClient();
  //       // const deviceManager = await callClient.getDeviceManager();
  //       // const microphones = await deviceManager.getMicrophones();
  //       // const cameras = await deviceManager.getCameras();
  //       // console.log(microphones, 'microphones', cameras)
  //       const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
  //       if (stream.getVideoTracks().length > 0) {
  //         setCameraEnabled(true);
  //       }
  //       if (stream.getAudioTracks().length > 0) {
  //         setMicrophoneEnabled(true);
  //       }
  //     } catch (error) {
  //       console.log("Error while checking devices", error);
  //     }
  //   };
  //   checkDeviceStatus();
  // }, []);
  // console.log(cameraEnabled, microphoneEnabled, 'app')
  useEffect(() => {
    document.documentElement.style.setProperty('--dc-color', darkColor);
    document.documentElement.style.setProperty('--banner-color', darkColor);
  }, [darkColor]);
  useEffect(() => {
    document.documentElement.style.setProperty('--lc-color', lightColor);
    saveDisplaySCToLocalStorage(lightColor);
  }, [lightColor]);
  useEffect(() => {
    document.documentElement.style.setProperty('--banner-color', darkColor);
    saveDisplaySCToLocalStorage(lightColor);
  }, [homeColor]);
  const listenScrollEvent = (e: any) => {
    if (window.scrollY > 700) {
      setClassname('fixed');
    } else {
      setClassname('default');
    }
  }

  const getMeetingIdFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('meetingId');
  }

  const getUserIdFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get('userId');
    if (userId) {
      return userId;
    } else {
      return sessionStorage.getItem('userId');
    }

  }

  useEffect(() => {
    // console.log(getMeetingIdFromUrl(), getUserIdFromUrl())
    if ((getMeetingIdFromUrl() && getUserIdFromUrl())) {
      const urlParams = new URLSearchParams(window.location.search);
      const meetingId = urlParams.get('meetingId');
      let userId: any = urlParams.get('userId') || '';
      if (userId) {
        sessionStorage.setItem('userId', userId);
        sessionStorage.setItem('sfContactId', userId);
      } else {
        userId = sessionStorage.getItem('userId');
      }
      //console.log(meetingId, userId)
      if (meetingId) {
        getMeetingInformation(meetingId, userId);
      } else {
        // if (sessionStorage.getItem('originURL')) {
        //   window.location.href = sessionStorage.getItem('originURL') || '';
        // } else {
        //   window.location.href = Default_URL;
        // }
      }
    }
  }, [defaultDisplayEmail, getMeetingIdFromUrl(), getUserIdFromUrl()])

  // useEffect(() => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const meetingId = urlParams.get('meetingId');
  //   var userId: any = urlParams.get('userId') || '';
  //   if (userId) {
  //     sessionStorage.setItem('userId', userId);
  //     sessionStorage.setItem('sfContactId', userId);
  //   } else {
  //     userId = sessionStorage.getItem('userId');
  //   }
  //   //console.log(meetingId, userId)
  //   if (meetingId) {
  //     getMeetingInformation(meetingId, userId);
  //   } else {
  //     if (sessionStorage.getItem('originURL')) {
  //       window.location.href = sessionStorage.getItem('originURL') || '';
  //     } else {
  //       window.location.href = Default_URL;
  //     }
  //   }
  // }, [])

  const getMeetingInformation = async (meetingId: any, userId: any) => {
    const meetingData: any = await getMeetingInformationData(meetingId, userId);
    // console.log(meetingData, 'meetingData')
    if (meetingData) {
      const resmeetingData = meetingData.data;
      if (resmeetingData && resmeetingData.success) {
        // console.log(resmeetingData.data)
        sessionStorage.setItem('originURL', resmeetingData.data.originURL);
        setLoader(true);
        setMeetingData(resmeetingData.data);
      }
    }
  }

  const getGroupIdFromUrl = () => {
    // const urlParams = new URLSearchParams(window.location.search);
    // return urlParams.get('groupId');
    return sessionStorage.getItem('groupId');
  };

  // const getThreadFromUrl = () => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   return urlParams.get('threadId');
  // }

  const getTeamsMeetingLinkFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('meeting');
  }

  const getMeetingLink = () => {
    const encodedTeamsMeetingLink = getTeamsMeetingLinkFromUrl()
    if (!encodedTeamsMeetingLink) {
      return '';
    }
    return decodeURIComponent(encodedTeamsMeetingLink);
  }

  const getGroupId = () => {
    const groupId = getGroupIdFromUrl();
    return groupId ? groupId : ''
  };

  const getLocator = (): GroupLocator | TeamsMeetingLinkLocator => {
    const meetingLink = getMeetingLink();

    if (meetingLink === '') {
      return { groupId: getGroupId() }
    } else {
      return { meetingLink: meetingLink }
    }
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const meetingId = urlParams.get('meetingId');
    const page = urlParams.get('page');
    // console.log(meetingId, defaultDisplayEmail)
    if (meetingId && defaultDisplayEmail && page == 'call') {
      setPage('configuration');
      // setPageLoader(true);
      setRejoin(false);
    }
    if (meetingId && defaultDisplayEmail && page == 'survey') {
      setPage('endCall');
    }
    // console.log(meetingId, localStorageAvailable)
    if (meetingId && !localStorageAvailable) {
      window.location.href = Default_URL + '?meetingId=' + meetingId;
    }
  }, [])

  const pagereload = () => {
    setRejoin(true);
    setPageLoader(false);
  }

  useEffect(() => {
    // console.log(page)
    if (page == 'endCall') {
      saveComments(messages);
      leaveMeeting(true, false);
    }
  }, [page])

  const saveComments = (messages: any) => {
    if (defaultDisplayEmail) {
      var splitMail = defaultDisplayEmail.split('@');
      if (splitMail.length == 2) {
        if (splitMail[1].toLowerCase() === 'liscr.com' || splitMail[1].toLowerCase() !== 'liscr.com') {
          var concatString = '';
          if (messages.length > 0) {
            messages.forEach((element: any) => {
              concatString += element.senderDisplayName + ': ' + element.content.message + '<br/>'
            });
          }
          var empCount: any = employeesCount;
          //console.log("concatString", employeesCount)
          if (empCount === 1) {
            //console.log("concatString")
            saveChatMessages(concatString.replace(/<br[^>]*>/g, "\n"));
            stopRecord();
          }
        }
      }
    }
  }

  const getContent = () => {
    if (page === 'configuration') {
      return (
        <ConfigurationScreen
          startCallHandler={(threadId: boolean, status: number, groupId: string) => {
            setGroupId(groupId);
            var datetime: any = new Date();
            if (!threadId && status === 1) {
              sessionStorage.setItem('datetime', datetime);
              setPage('call');
            } else if (!threadId && status === 2) {
              window.history.pushState({}, '', window.location.href.split('?')[0]);
            } if (threadId && status === 3) {
              sessionStorage.setItem('datetime', datetime);
              setPage('call');
            } else {
              sessionStorage.setItem('datetime', datetime);
              setPage('call');
            }
            setLoader(true);
          }}
          scheduleMeeting={() => {
            setPage('scheduleMeeting');
          }}
          startCallLoader={(loader: boolean) => {
            setLoader(loader);
          }}
          startCall={(loader: boolean) => {
            setCall(loader);
          }}
          joinTeamsMeeting={(meetingUrl: string) => {
          }}
          unsupportedStateHandler={unsupportedStateHandler}
          callEndedHandler={(errorMsg: CallEndReason) => { setCallEndReason(errorMsg); setPage('error'); }}
          screenWidth={screenWidth}
          darkColor={darkColor}
          lightColor={lightColor}
          homeColor={darkColor}
          rejoin={rejoin}
          pageLoader={pageLoader}
          reCall={() => {
            setPage('call');
            setLoader(true);
            setPageLoader(false);
            setRejoin(false);
          }}
          reJoinLoad={() => {
            setPage('call');
            setLoader(true);
            setRejoin(false);
          }}
          meetingData={meetingData}
        />
      );
    } else if (page === 'call') {
      return (
        <GroupCall
          endCallHandler={(messages: any) => {
            if (defaultDisplayEmail) {
              const splitMailEmp = defaultDisplayEmail.split('@');
              if (splitMailEmp.length == 2) {
                if (splitMailEmp[1].toLowerCase() === 'liscr.com') {
                  window.history.pushState({}, '', window.location.href.split('?')[0]);
                  window.history.pushState({}, '', window.location.href + '?page=thankyou' + '&&meetingId=' + sessionStorage.getItem('meetingId'));
                  setPage('thankyou');
                  setUserMessage('Thank you for joining the call');
                } else {
                  window.history.pushState({}, '', window.location.href.split('?')[0]);
                  window.history.pushState({}, '', window.location.href + '?page=survey' + '&&meetingId=' + sessionStorage.getItem('meetingId'));
                  setPage('endCall');
                  setUserMessage('Thank you for submitting the survey');
                  setMessages(messages);
                }
              }
            } else {
              window.history.pushState({}, '', window.location.href.split('?')[0]);
              window.history.pushState({}, '', window.location.href + '?page=survey' + '&&meetingId=' + sessionStorage.getItem('meetingId'));
              setPage('endCall');
              setUserMessage('Thank you for submitting the survey');
              setMessages(messages);
            }
          }}
          locator={getLocator()}
          screenWidth={screenWidth}
          groupId={groupId}
          darkColor={darkColor}
          lightColor={lightColor}
          updateEmpCount={(count: any) => {
            setEmployeesCount(count);
          }}
          endCallDisconnect={() => {
            if (defaultDisplayEmail) {
              const splitMailEmp = defaultDisplayEmail.split('@');
              if (splitMailEmp.length == 2) {
                if (splitMailEmp[1].toLowerCase() === 'liscr.com') {
                  window.history.pushState({}, '', window.location.href.split('?')[0]);
                  window.history.pushState({}, '', window.location.href + '?page=thankyou' + '&&meetingId=' + sessionStorage.getItem('meetingId'));
                  setPage('thankyou')
                  setUserMessage('Thank you for joining the call');
                } else {
                  window.history.pushState({}, '', window.location.href.split('?')[0]);
                  window.history.pushState({}, '', window.location.href + '?page=survey' + '&&meetingId=' + sessionStorage.getItem('meetingId'));
                  setPage('endCall');
                  setUserMessage('Thank you for submitting the survey');
                  setMessages(messages);
                }
              }
            } else {
              window.history.pushState({}, '', window.location.href.split('?')[0]);
              window.history.pushState({}, '', window.location.href + '?page=survey' + '&&meetingId=' + sessionStorage.getItem('meetingId'));
              setPage('endCall');
              setUserMessage('Thank you for submitting the survey');
            }
          }}
        />
      );
    } else if (page === 'endCall') {
      return (
        <EndCall
          message={'Thank you for joining the call'}
          rejoinHandler={() => setPage('call')}
          homeHandler={() => {
            window.history.pushState({}, '', window.location.href.split('?')[0]);
            window.history.pushState({}, '', window.location.href + '?page=thankyou' + '&&meetingId=' + sessionStorage.getItem('meetingId'));
            setPage('thankyou')
            setUserMessage('Thank you for submitting the survey');
          }}
          darkColor={darkColor}
          lightColor={lightColor}
        />
      );
    }
    // else if (page === 'survey') {
    //   return (
    //     <Survey
    //       message={'Fill out an Survey'}
    //       homeHandler={() => {
    //         setPage('thankyou');
    //         window.history.pushState({}, '', window.location.href.split('?')[0]);
    //       }}
    //     />
    //   );
    // } 
    else if (page === 'thankyou') {
      return (
        <Thankyou
          message={userMessage}
          rejoinHandler={() => {
            setPage('configuration');
            // window.history.pushState({}, '', window.location.href.split('?')[0]); 
            window.location.href = sessionStorage.getItem('originURL') || '';
          }}
          homeHandler={() => {
            setPage('configuration');
            window.history.pushState({}, '', window.location.href.split('?')[0]);
          }}
          darkColor={darkColor}
          lightColor={lightColor}
        />
      );
    } else if (page === 'scheduleMeeting') {
      return (
        <ScheduleMeeting
          startCallHandler={() => {
            setPage('configuration');
          }}
        />
      );
    } else if (page === 'unsupported') {
      window.document.title = 'Unsupported browser';
      // function createData(
      //   platform: string,
      //   chrome: string,
      //   safari: string,
      //   edge: string,
      //   firefox: string,
      //   webview: string,
      // ) {
      //   return { platform, chrome, safari, edge, firefox, webview };
      // }

      // const rows = [
      //   createData('Android', '✔️', '❌', '❌', '❌', '✔️ *'),
      //   createData('iOS', '❌', '✔️', '❌', '❌', '❌'),
      //   createData('macOS', '✔️', '✔️', '✔️', '✔️', '❌'),
      //   createData('Windows', '✔️', '❌', '✔️', '✔️', '❌'),
      //   createData('Ubuntu/Linux', '✔️', '❌', '❌', '❌', '❌'),
      // ];
      return (
        <div style={{ position: 'relative', top: '200px', textAlign: 'center', color: darkColor, maxWidth: 750, margin: '0px auto' }}>
          {/* <a href="https://docs.microsoft.com/en-us/azure/communication-services/concepts/voice-video-calling/calling-sdk-features#calling-client-library-browser-support">Learn more</a>&nbsp;about
          browsers and platforms supported by the web calling sdk */}
          <h4>To continue using duty officer video call (DOVC) application, please use Chrome/Edge.</h4>
          {/* <img src={browserList} /> */}
          {/* <h5> The following table represents the set of supported browsers which are currently available. We support the most recent three major versions of the browser (most recent three minor versions for Safari) unless otherwise indicated.</h5> */}

          {/* <TableContainer component={Paper}> */}
          {/* <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Platform</TableCell>
                <TableCell align="center">Chrome</TableCell>
                <TableCell align="center">Safari</TableCell>
                <TableCell align="center">Edge</TableCell>
                <TableCell align="center">Firefox</TableCell>
                <TableCell align="center">Webview</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow
                  key={row.platform}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.platform}
                  </TableCell>
                  <TableCell align="center">{row.chrome}</TableCell>
                  <TableCell align="center">{row.safari}</TableCell>
                  <TableCell align="center">{row.edge}</TableCell>
                  <TableCell align="center">{row.firefox}</TableCell>
                  <TableCell align="center">{row.webview}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table> */}
          {/* </TableContainer> */}
        </div>
      );
    } else if (page === 'error') {
      window.document.title = 'Call Ended';
      return (
        <div style={{ position: 'relative', top: '200px', textAlign: 'center', color: darkColor }}>
          <div>{`The call has ended with this error code (Code: ${callEndReason?.code} Subcode: ${callEndReason?.subCode})`}</div >
          {/* <div>
            <a href="https://docs.microsoft.com/en-us/azure/communication-services/concepts/troubleshooting-info?tabs=csharp%2Cjavascript%2Cdotnet">Learn more</a>&nbsp;about
            why this Azure Communication Services call has ended.</div> */}
        </div>
      );
    } else {
      return <></>
    }
  };
  const clickSettingIcon = async () => {
    setSettingBox(!settingBox)
    // console.log(true, 'const clickConnectNow = async () => {')
  }
  const handleClick1 = () => {
    // console.log('111111111111111', colorPicker1)
    if (colorPicker2) {
      setColorPicker2(!colorPicker2)
    }
    setColorPicker1(!colorPicker1)
    // console.log(true, 'const clickConnectNow = async () => {')
  }
  const handleClick2 = () => {
    if (colorPicker1) {
      setColorPicker1(!colorPicker1)
    }
    // console.log('111111111111111', colorPicker2)
    setColorPicker2(!colorPicker2)
    // console.log(true, 'const clickConnectNow = async () => {')
  }
  const onValueChange = (e: any) => {
    const name = e.target.name;
    const newValue = e.target.value;
    //console.log(newValue, name)
    if (newValue === undefined) {
      return;
    }
    if (name === 'color1') {
      setDarkColor1(newValue);
    } else if (name === 'color2') {
      setLightColor1(newValue);
    }
    else if (name === 'color3') {
      setHomeColor(newValue);
    }
  };
  const onValueBlur = (e: any) => {
    const name = e.target.name;
    const newValue = e.target.value;
    //console.log(newValue, name)
    if (newValue === undefined) {
      return;
    }
    if (name === 'color1') {
      setDarkColor(newValue);
    } else if (name === 'color2') {
      setLightColor(newValue);
    }
    else if (name === 'color3') {
      setHomeColor(newValue);
    }
  };
  const handleChangeComplete = (color: any, event: any) => {
    setDarkColor(color.hex);
    setDarkColor1(color.hex);
  };
  const handleChangeComplete2 = (color: any, event: any) => {
    setLightColor(color.hex);
    setLightColor1(color.hex);
  };

  return <Provider store={store}>
    <div style={{ height: (page === 'configuration' ? '100%' : '100%') }}>
      <Paper style={{ height: '96%', boxShadow: '0px 2px 4px -1px rgb(255 255 255 / 0%), 0px 4px 5px 0px rgb(255 255 255 / 0%), 0px 1px 10px 0px rgb(255 255 255 / 0%)' }}>
        {/* {(page === 'endCall' && loader) ? <style>
          {`  body, html, .Root{
              // overflow: auto;
               }`}

        </style> : <style>
          {`  body, html, .Root{
              overflow: hidden;
               }`}

        </style>} */}

        <Router>
          {page === 'configuration' ? '' : <Header
            page={page}
            loader={loader}
            className={className}
            rejoinHandler={() => {
              // pagereload();
              // setPage('configuration');
              leaveMeeting(false, true);
              window.history.pushState({}, '', window.location.href.split('?')[0]);
              window.history.pushState({}, '', window.location.href + '?page=call' + '&&meetingId=' + sessionStorage.getItem('meetingId'));
              window.location.reload();
            }}
            darkColor={darkColor}
            lightColor={lightColor}
          />
          }
          <Tooltip title={settingBox ? 'Close Color Picker Settings' : 'Open Color Picker Settings'} placement="top-start">
            <div className='colorplanet'>
              <SettingsIcon className='applicationset1' onClick={() => clickSettingIcon()} />
            </div>
          </Tooltip>
          {settingBox &&
            <div className='colorplanetpanelheader'>
              {colorPicker1 &&
                <div style={{ position: 'fixed', right: '246px' }}>
                  <SketchPicker
                    color={darkColor}
                    onChangeComplete={handleChangeComplete}
                  // style={inputStyles}
                  />
                </div>
              }
              {colorPicker2 &&
                <div style={{ position: 'fixed', right: '246px' }}>
                  <SketchPicker
                    color={lightColor}
                    onChangeComplete={handleChangeComplete2}
                  // style={inputStyles}
                  />
                </div>
              }
              <div className='colourlinebox1'>
                <Tooltip title={colorPicker1 ? 'Close Primary Color Picker' : 'Open Primary Color Picker'} placement="top-start">
                  <div className='clourboxv' onClick={handleClick1}></div>
                </Tooltip>
                <TextField
                  id="standard-basic"
                  label="Primary Color"
                  name="color1"
                  variant="standard"
                  InputLabelProps={{ style: { fontSize: '18px', fontWeight: '500', color: darkColor } }}
                  InputProps={{ style: { fontSize: '24px', color: '#707070' } }}
                  // className={classes.fieldnamepanel2}
                  style={{
                    width: '83%',
                    fontSize: '24px',
                    fontFamily: 'Segoe UI',
                  }}
                  required
                  onBlur={(e) => onValueBlur(e)}
                  onChange={(e) => onValueChange(e)}
                  defaultValue={darkColor}
                  value={darkColor1}
                  autoComplete='off'
                />
              </div>

              <div className='colourlinebox2'>
                <Tooltip title={colorPicker2 ? 'Close Secondary Color Picker' : 'Open Secondary Color Picker'} placement="top-start">
                  <div className='clourboxv1' onClick={handleClick2}></div>
                </Tooltip>
                <TextField
                  id="standard-basic"
                  label="Secondary Color"
                  name="color2"
                  variant="standard"
                  InputLabelProps={{ style: { fontSize: '18px', fontWeight: '500', color: darkColor } }}
                  InputProps={{ style: { fontSize: '24px', color: '#707070' } }}
                  // className={classes.fieldnamepanel2}
                  style={{
                    width: '83%',
                    fontSize: '24px',
                    fontFamily: 'Segoe UI',
                  }}
                  required
                  onChange={(e) => onValueChange(e)}
                  onBlur={(e) => onValueBlur(e)}
                  defaultValue={lightColor}
                  value={lightColor1}
                  autoComplete='off'
                /></div>
              {/* 
              <div className='colourlinebox2'><div className='clourboxv2'></div> <TextField
                id="standard-basic"
                label="Color 3"
                name="color3"
                variant="standard"
                InputLabelProps={{ style: { fontSize: '18px', fontWeight: '500', color: darkColor } }}
                InputProps={{ style: { fontSize: '24px', color: '#707070' } }}
                // className={classes.fieldnamepanel2}
                style={{
                  width: '83%',
                  fontSize: '24px',
                  fontFamily: 'Segoe UI',
                }}
                required
                onBlur={(e) => onValueChange(e)}
                defaultValue={homeColor}
                autoComplete='off'
              /></div> */}
            </div>
          }
          {loader ? (
            <Fragment>
              {getContent()}
            </Fragment>
          ) : (
            <Spinner label={spinnerLabel} ariaLive="assertive" labelPosition="top" style={{ marginTop: 100 }} />
          )}
        </Router>
      </Paper>
    </div>
  </Provider >;
};

window.setTimeout(() => {
  try {
    // console.log(`Azure Communication Services sample group calling app: ${lastUpdated}`);
  } catch (e) { }
}, 0);

export default App;
